import { observer } from 'mobx-react'
import { Card, CardBody, CardHeader } from 'reactstrap'
import React from 'react'
import { observable, toJS } from 'mobx'
import Util from '../../common/Util'
import ApiClient, { ApiRoutes } from '../../api/ApiClient'
import { route } from '../../routes/routes'
import LoadingPanel from '../LoadingPanel'
import _ from 'lodash'

type ClosedChaptersData = {
  closedChaptersCount: {
    day: number
    month: number
    year: number
  }
}

type Props = {
  filters: {
    state?: string
    areaId?: number
    chapterId?: number
  }
  onShowChaptersList: (url: string, title: string) => void
}

@observer
export default class ClosedChaptersDashboard extends React.Component<Props> {
  @observable
  private closedChapters?: ClosedChaptersData
  @observable
  private error?: string
  @observable
  private loading = false

  componentDidMount () {
    this.loadData().then()
  }

  componentDidUpdate (prevProps: Readonly<Props>, prevState: Readonly<{}>, snapshot?: any) {
    if (!_.isEqual(toJS(prevProps.filters), toJS(this.props.filters))) {
      this.loadData().then()
    }
  }

  private loadData = async () => {
    try {
      this.error = undefined
      this.loading = true

      const response = await ApiClient.getInstance().get(route(ApiRoutes.dashboard.closedChapters, {}, this.props.filters))

      this.closedChapters = response.data

      this.loading = false
    } catch (err) {
      this.error = Util.extractErrorMessage(err.response)
    }
  }

  render () {
    return <Card>
      <CardHeader>
        <b>Closed Chapters</b>
      </CardHeader>
      <CardBody>
        <LoadingPanel loading={this.loading} loaded={!!this.closedChapters} error={this.error}>
          {
            this.closedChapters
              ? <>
                <div className="d-flex">
                  <div className="flex-fill">
                    Today
                  </div>
                  <div className="text-right">
                    <a href="" onClick={ev => {
                      ev.preventDefault()
                      this.props.onShowChaptersList(route(ApiRoutes.dashboard.closedChapters, {}, {
                        ...this.props.filters,
                        list: 'day',
                      }), 'Closed Chapters Today')
                    }}>
                    {Util.formatNumber(this.closedChapters!.closedChaptersCount.day)}
                    </a>
                  </div>
                </div>
                <div className="d-flex">
                  <div className="flex-fill">
                    This Month
                  </div>
                  <div className="text-right">
                    <a href="" onClick={ev => {
                      ev.preventDefault()
                      this.props.onShowChaptersList(route(ApiRoutes.dashboard.closedChapters, {}, {
                        ...this.props.filters,
                        list: 'month',
                      }), 'Closed Chapters This Month')
                    }}>
                    {Util.formatNumber(this.closedChapters!.closedChaptersCount.month)}
                    </a>
                  </div>
                </div>
                <div className="d-flex">
                  <div className="flex-fill">
                    This Year
                  </div>
                  <div className="text-right">
                    <a href="" onClick={ev => {
                      ev.preventDefault()
                      this.props.onShowChaptersList(route(ApiRoutes.dashboard.closedChapters, {}, {
                        ...this.props.filters,
                        list: 'year',
                      }), 'Closed Chapters This Year')
                    }}>
                    {Util.formatNumber(this.closedChapters!.closedChaptersCount.year)}
                    </a>
                  </div>
                </div>
              </>
              : null
          }
        </LoadingPanel>
      </CardBody>
    </Card>
  }
}
